import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "form-control",
  readonly: ""
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "​", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 2,
  class: "form-select",
  readonly: ""
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "​", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.value !== _ctx.loadingPlaceholder)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.noDefault)
          ? _renderSlot(_ctx.$slots, "default", {
              key: 0,
              value: _ctx.value
            })
          : _renderSlot(_ctx.$slots, "default", {
              key: 1,
              value: _ctx.value
            }, () => [
              _createTextVNode(_toDisplayString(_ctx.value), 1)
            ])
      ], 64))
    : (_ctx.input)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_ctx.select)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.lines, (line) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: line }, [
              _createElementVNode("span", {
                class: "placeholder",
                style: _normalizeStyle({ width: `${_ctx.width}em` })
              }, null, 4),
              (line !== _ctx.lines)
                ? (_openBlock(), _createElementBlock("br", _hoisted_7))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
}